import { KeyFilterPattern } from 'primeng/keyfilter';
import {
  FormControlConfig,
  IFormControlConfig,
} from '../eo-base-form-control/eo-base-form-control.model';

export interface IEoTextAreaConfig extends IFormControlConfig {
  autoResize?: boolean;
  rows?: number;
  cols?: number;
  maxlength?: number;
  minlength?: number;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  resizable?: boolean;
  showClear?: boolean;
  inputStyleClass?: string;
  pKeyFilter?: RegExp | KeyFilterPattern | null;
}

export class EoTextAreaConfig extends FormControlConfig implements IEoTextAreaConfig {
  autoResize?: boolean;
  rows?: number;
  cols?: number;
  maxlength?: number;
  minlength?: number;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  resizable?: boolean;
  showClear?: boolean;
  inputStyleClass?: string;
  pKeyFilter?: RegExp | KeyFilterPattern | null;

  constructor();
  constructor(obj: IEoTextAreaConfig);
  constructor(obj?: IEoTextAreaConfig) {
    super(obj as IFormControlConfig);
    this.autoResize = obj?.autoResize ?? false;
    this.rows = obj?.rows ?? 2;
    this.cols = obj?.cols ?? 20;
    this.maxlength = obj?.maxlength;
    this.minlength = obj?.minlength;
    this.placeholder = obj?.placeholder;
    this.readonly = obj?.readonly ?? false;
    this.disabled = obj?.disabled ?? false;
    this.resizable = obj?.resizable ?? true;
    this.showClear = obj?.showClear ?? false;
    this.inputStyleClass = obj?.inputStyleClass;
    this.pKeyFilter = obj?.pKeyFilter;
  }
}